'use client';
import styles from './ProductInfo.module.css';

export default function ProductInfo({ specs }) {
  const infoItems = [
    { label: 'Servings', value: specs.servings, icon: '📦' },
    { label: 'Dosage', value: specs.dosage, icon: '💊' },
    { label: 'Form', value: specs.form, icon: '⚡' },
    { label: 'Certified', value: specs.certified, icon: '✓' },
  ];

  return (
    <div className={styles.infoCard}>
      {infoItems.map((item, idx) => (
        <div key={idx} className={styles.infoItem}>
          <span className={styles.icon}>{item.icon}</span>
          <div className={styles.infoContent}>
            <span className={styles.label}>{item.label}</span>
            <span className={styles.value}>{item.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
